// Environment configuration
// Reads VITE_* environment variables from .env files

interface EnvConfig {
  sparqlEndpoint: string;
  sparqlMetadataEndpoint: string;
  sparqlRinfEndpoint: string;
  oauthEndpoint: string;
  fileServiceEndpoint: string;
  maptilerKey: string;
  mapboxToken: string;
  appEnv: string;
  isDevelopment: boolean;
  isProduction: boolean;
  dataBaseUri: string;
  ontologyBaseUri: string;
  describeEndpoint: string;
  statusReportsBase: string;
  catalogBase: string;
  rinfStatusBase: string;
  tpsViewerApiBase: string;
  railmlStatusBase: string;
}

const env: EnvConfig = {
  sparqlEndpoint: import.meta.env.VITE_SPARQL_ENDPOINT || '/sparql',
  sparqlMetadataEndpoint: import.meta.env.VITE_SPARQL_METADATA_ENDPOINT || '/sparql-metadata',
  // Fuseki /rinf-bn, proxied by nginx like /sparql (deploy/nginx.conf)
  sparqlRinfEndpoint: import.meta.env.VITE_SPARQL_RINF_ENDPOINT || '/sparql-rinf',
  oauthEndpoint: import.meta.env.VITE_OAUTH_ENDPOINT || '/oauth2',
  fileServiceEndpoint: import.meta.env.VITE_FILE_SERVICE_ENDPOINT || '/download',
  maptilerKey: import.meta.env.VITE_MAPTILER_KEY || '',
  mapboxToken: import.meta.env.VITE_MAPBOX_TOKEN || '',
  appEnv: import.meta.env.VITE_APP_ENV || 'development',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  dataBaseUri: import.meta.env.VITE_DATA_BASE_URI || 'https://data.banenor.no/data/',
  ontologyBaseUri: import.meta.env.VITE_ONTOLOGY_BASE_URI || 'https://data.banenor.no/ontology/',
  describeEndpoint: import.meta.env.VITE_DESCRIBE_ENDPOINT || '/describe',
  // Status reports are built in dim-docs and uploaded to website/status-reports/ on the
  // file share, and served by nginx under /status-reports/files/ (deploy/nginx.conf)
  statusReportsBase: import.meta.env.VITE_STATUS_REPORTS_BASE || '/status-reports/files',
  // Data catalog files, written by the documentation_data_catalog DAGs (dim-etl-documentation)
  // to datasets/catalog/ on the file share, and served by nginx under /catalog/files/
  catalogBase: import.meta.env.VITE_CATALOG_BASE || '/catalog/files',
  // RINF status file, written by the rinf-status DAG (dim-etl-rinf-generation)
  // to datasets/rinf-status/ on the file share, and served by nginx under /rinf-status/files/
  rinfStatusBase: import.meta.env.VITE_RINF_STATUS_BASE || '/rinf-status/files',
  // Read-only API of the tps-topo-matching service, proxied by nginx (deploy/nginx.conf)
  tpsViewerApiBase: import.meta.env.VITE_TPS_VIEWER_API_BASE || '/tps-viewer-api',
  // railML status file, written by the railml_status DAG (dim-etl-railml-generation)
  // to datasets/railml-status/ on the file share, and served by nginx under /railml-status/files/
  railmlStatusBase: import.meta.env.VITE_RAILML_STATUS_BASE || '/railml-status/files',
};

export default env;
